<template>
  <div class="liftManagementList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item v-if="this.gardenId === 0">
          <el-select v-model="GardenIdId">
            <el-option key :label="$t('lang.villageall')" :value="0"></el-option>
            <el-option
              v-for="(item,index) in types"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="this.gardenId != 0">
          <el-select v-model="gardenId" :disabled="this.gardenId != 0">
            <el-option
              v-for="(item,index) in types"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="elevatorErrorSystem1" @change="getSystemErroeLevel2">
            <el-option key :label="$t('lang.lab_chooseSystemLevel1')" :value="0"></el-option>
            <el-option
              v-for="(item,index) in elevatorErrorSystem1List"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="elevatorErrorSystem2">
            <el-option key :label="$t('lang.lab_chooseSystemLevel2')" :value="0"></el-option>
            <el-option
              v-for="(item,index) in elevatorErrorSystem2List"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <br/>
        <el-form-item>
          <el-select v-model="elevatorErrorParts1" @change="getBodyErroeLevel2">
            <el-option key :label="$t('lang.lab_chooseBodyLevel1')" :value="0"></el-option>
            <el-option
              v-for="(item,index) in elevatorErrorParts1List"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="elevatorErrorParts2" @change="getBodyErroeLevel3">
            <el-option key :label="$t('lang.lab_chooseBodyLevel2')" :value="0"></el-option>
            <el-option
              v-for="(item,index) in elevatorErrorParts2List"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="elevatorErrorParts3">
            <el-option key :label="$t('lang.lab_chooseBodyLevel3')" :value="0"></el-option>
            <el-option
              v-for="(item,index) in elevatorErrorParts3List"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="excelDownloadClick">{{$t('lang.btn_excelDl')}}</el-button>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
         :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
      >
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="userName" :label="$t('lang.lbl_liftManagement_userName')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.userName&&scope.row.userName.length> require('@/config/enum').tableDatamaxlength5"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.userName }}
                </span>
              </div>
              <div>
                {{ scope.row.userName.substring(0, require('@/config/enum').tableDatamaxlength5) | valueIsNull }}
                <span
                  v-if="scope.row.userName.length>require('@/config/enum').tableDatamaxlength5"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.userName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="garden.name" :label="$t('lang.lbl_liftManagement_garden_name')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.garden.name&&scope.row.garden.name.length> require('@/config/enum').tableDatamaxlength5"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.garden.name }}
                </span>
              </div>
              <div>
                {{ scope.row.garden.name.substring(0, require('@/config/enum').tableDatamaxlength5) | valueIsNull }}
                <span
                  v-if="scope.row.garden.name.length>require('@/config/enum').tableDatamaxlength5"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.garden.name | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="beginSource" :label="$t('lang.lbl_liftManagement_beginSource')">
          <template slot-scope="scope">
            <span v-if="scope.row.beginSource">
              <span v-if="scope.row.beginSource === 1 && scope.row.quartzJobId === 0">
                {{$t('lang.lab_backgroundSupplement')}}
              </span>
              <span v-if="scope.row.beginSource === 1 && scope.row.quartzJobId > 0">
                {{$t('lang.lab_automaticPatrolWorkOrder')}}
              </span>
              <span v-if="scope.row.beginSource === 2">
                {{$t('lang.lab_ownersRepor')}}
              </span>
              <span v-if="scope.row.beginSource === 3 && scope.row.quartzJobId == 0">
                {{$t('lang.lab_propertySupplement')}}
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lbl_liftManagement_createTime')">
          <template slot-scope="scope">
            <span v-if="scope.row.createTime">
              {{ scope.row.createTime | timeYMD }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="garden.grids.houseName" :label="$t('lang.lbl_liftManagement_garden_grids_houseName')"></el-table-column>
        <el-table-column prop="garden.grids.unitName" :label="$t('lang.lbl_liftManagement_garden_grids_unitName')"></el-table-column>
        <el-table-column prop="garden.grids.roomName" :label="$t('lang.lbl_liftManagement_garden_grids_roomName')"></el-table-column>
        <el-table-column prop="maintainType1.name" :label="$t('lang.lbl_liftManagement_maintainType1_name')" width="80px"></el-table-column>
        <el-table-column prop="normal" :label="$t('lang.lbl_liftManagement_normal')">
          <template slot-scope="scope">
            <span v-if="scope.row.normal === 0">
              {{$t('lang.lab_normalLift')}}
            </span>
            <span v-if="scope.row.normal === 1">
              {{$t('lang.lab_outlLift')}}
            </span>
            <span v-if="scope.row.normal === 2">
              {{$t('lang.lab_normalLift')}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="state" :label="$t('lang.lbl_liftManagement_state')" width="80px">
          <template slot-scope="scope">
            <span v-if="scope.row.state === 1">
              {{$t('lang.lab_papereconfirmed')}}
            </span>
            <span v-if="scope.row.state === 2">
              {{$t('lang.lab_paperesolved')}}
            </span>
            <span v-if="scope.row.state === 3">
              {{$t('lang.lab_paperefinsh')}}
            </span>
            <span v-if="scope.row.state === 4">
              {{$t('lang.lab_paperealreadyevaluated')}}
            </span>
            <span v-if="scope.row.state === 5">
              {{$t('lang.lab_paperecloses')}}
            </span>
            <span v-if="scope.row.state === 6">
              {{$t('lang.lab_paperenoclose')}}
            </span>
            <span v-if="scope.row.state === 7">
              {{$t('lang.lab_Revoked')}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="staffId" :label="$t('lang.lbl_liftManagement_staffId')"></el-table-column>
        <el-table-column prop="content" :label="$t('lang.lbl_liftManagement_content')" width="200px">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.content&&scope.row.content.length> require('@/config/enum').tableDatamaxlength12"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.content }}
                </span>
              </div>
              <div>
                {{ scope.row.content.substring(0, require('@/config/enum').tableDatamaxlength12) | valueIsNull }}
                <span
                  v-if="scope.row.content.length>require('@/config/enum').tableDatamaxlength12"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.content | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="evaluate" :label="$t('lang.lbl_liftManagement_evaluate')">
          <template slot-scope="scope">
            <span v-if="scope.row.evaluate === 0">
              {{$t('lang.lab_paperevaluateres')}}
            </span>
            <span v-if="scope.row.evaluate === 1">
              {{$t('lang.lab_paperevaluateyes')}}
            </span>
            <span v-if="scope.row.evaluate === 2">
              {{$t('lang.lab_paperevaluatesoso')}}
            </span>
            <span v-if="scope.row.evaluate === 3">
              {{$t('lang.lab_paperenovaluate')}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width1">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_detail')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout=" sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
// 引入富文本title汉字
import { excelDownload } from '../../../config/download.js'
/**
 *@ClassName:liftManagementList
 *@Description:电梯管理列表
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-03-23
 */

export default {
  name:'/manage/main.maintainElevatorErrorList',
  data() {
    return {
      gardenId: this.$store.getters.gardenId,
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      GardenIdId: 0, // 小区绑定的Id（接口绑定的）
      multipleSelection: [], // 多选框
      types: [], // 小区列表
      type: 1, // 筛选条件的层级标注
      elevatorErrorSystem1: 0, // 电梯系统异常1级分类
      elevatorErrorSystem2: 0, // 电梯系统异常2级分类
      elevatorErrorSystem1List: [], // 电梯系统异常1级分类列表
      elevatorErrorSystem2List: [], // 电梯系统异常2级分类列表
      elevatorErrorParts1: 0, // 电梯部件异常1级分类
      elevatorErrorParts2: 0, // 电梯部件异常2级分类
      elevatorErrorParts3: 0, // 电梯部件异常3级分类
      elevatorErrorParts1List: [], // 电梯部件异常1级分类列表
      elevatorErrorParts2List: [], // 电梯部件异常2级分类列表
      elevatorErrorParts3List: [], // 电梯部件异常3级分类列表
      tableData: [], // 列表数组
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
      isDisabled: true, // 保存的可点击
      isPopupPage: false, // 弹框的显示控制
      isAdd: false, // 标识新增(true)或编辑(false)
      diaForm: {
        gardenId: '', // 物业分类/项目分类
        name: '', // 分类名称
      },
      gardenIdlist: [], // 物业分类/项目分类列表
      name: '', // 分类名称
    }
  },
  created () {
    this.getTablelist()
    this.getGardenId()
    this.getSystemErroeLevel1()
    this.getBodyErroeLevel1()
  },
  methods: {
    // 表格下载
    excelDownloadClick() {
      if (navigator.onLine) {
        // Excel表头
        const tHeader = [
          this.$i18n.t('lang.lbl_liftManagement_userName'),
          this.$i18n.t('lang.lbl_liftManagement_garden_name'),
          this.$i18n.t('lang.lbl_liftManagement_beginSource'),
          this.$i18n.t('lang.lbl_liftManagement_createTime'),
          this.$i18n.t('lang.lbl_liftManagement_garden_grids_houseName'),
          this.$i18n.t('lang.lbl_liftManagement_garden_grids_unitName'),
          this.$i18n.t('lang.lbl_liftManagement_garden_grids_roomName'),
          this.$i18n.t('lang.lbl_liftManagement_maintainType1_name'),
          this.$i18n.t('lang.lbl_liftManagement_normal'),
          this.$i18n.t('lang.lbl_liftManagement_state'),
          this.$i18n.t('lang.lbl_liftManagement_staffId'),
          this.$i18n.t('lang.lbl_liftManagement_content'),
          this.$i18n.t('lang.lbl_liftManagement_evaluate'),
        ]
        // 对应table数据的列字段名
        let newArr = []
        let houseName = ''
        let unitName = ''
        let roomName = ''
        let maintainType1 = ''
        let beginSource = ''
        let normal = ''
        let state = ''
        let evaluate = ''
        if (this.tableData.length > 0) {
          for (let i = 0; i < this.tableData.length; i++) {
            // 判断楼号单元房间号是否存在
            if (this.tableData[i].garden.grids) {
              houseName = this.tableData[i].garden.grids.houseName
              unitName = this.tableData[i].garden.grids.unitName
              roomName = this.tableData[i].garden.grids.roomName
            }
            // 判断报事方式
            if (this.tableData[i].beginSource === 1 && this.tableData[i].quartzJobId === 0) {
              beginSource = this.$i18n.t('lang.lab_backgroundSupplement')
            } else if (this.tableData[i].beginSource === 1 && this.tableData[i].quartzJobId > 0) {
              beginSource = this.$i18n.t('lang.lab_automaticPatrolWorkOrder')
            } else if (this.tableData[i].beginSource === 2) {
              beginSource = this.$i18n.t('lang.lab_ownersRepor')
            } else if (this.tableData[i].beginSource === 3 && this.tableData[i].quartzJobId === 0) {
              beginSource = this.$i18n.t('lang.lab_propertySupplement')
            }
            // 判断报事类型是否存在
            if (this.tableData[i].maintainType1.name) {
              maintainType1 = this.tableData[i].maintainType1.name
            }
            // 判断工单类型
            if (this.tableData[i].normal === 0) {
              normal = this.$i18n.t('lang.lab_normalLift')
            } else if (this.tableData[i].normal === 1) {
              normal = this.$i18n.t('lang.lab_outlLift')
            } else if (this.tableData[i].normal === 2) {
              normal = this.$i18n.t('lang.lab_normalLift')
            }
            // 判断工单状态
            if (this.tableData[i].state === 1) {
              state = this.$i18n.t('lang.lab_papereconfirmed')
            } else if (this.tableData[i].state === 2) {
              state = this.$i18n.t('lang.lab_paperesolved')
            } else if (this.tableData[i].state === 3) {
              state = this.$i18n.t('lang.lab_paperefinsh')
            } else if (this.tableData[i].state === 4) {
              state = this.$i18n.t('lang.lab_paperealreadyevaluated')
            } else if (this.tableData[i].state === 5) {
              state = this.$i18n.t('lang.lab_paperecloses')
            } else if (this.tableData[i].state === 6) {
              state = this.$i18n.t('lang.lab_paperenoclose')
            } else if (this.tableData[i].state === 7) {
              state = this.$i18n.t('lang.lab_Revoked')
            }
            // 判断满意度
            if (this.tableData[i].evaluate === 0) {
              evaluate = this.$i18n.t('lang.lab_paperevaluateres')
            } else if (this.tableData[i].evaluate === 1) {
              evaluate = this.$i18n.t('lang.lab_paperevaluateyes')
            } else if (this.tableData[i].evaluate === 2) {
              evaluate = this.$i18n.t('lang.lab_paperevaluatesoso')
            } else if (this.tableData[i].evaluate === 3) {
              evaluate = this.$i18n.t('lang.lab_paperenovaluate')
            }
            newArr.push({
              'userName': this.tableData[i].userName,
              'garden.name': this.tableData[i].garden.name,
              'beginSource': beginSource,
              'timestampymd': this.tableData[i].createTime,
              'garden.grids.houseName': houseName,
              'garden.grids.unitName': unitName,
              'garden.grids.roomName': roomName,
              'maintainType1.name': maintainType1,
              'normal': normal,
              'state': state,
              'staffId': this.tableData[i].staffId,
              'content': this.tableData[i].content,
              'evaluate': evaluate,
            })
          }
        }
        const filterVal = ['userName', 'garden.name', 'beginSource', 'timestampymd', 'garden.grids.houseName', 'garden.grids.unitName', 'garden.grids.roomName',
                          'maintainType1.name', 'normal', 'state', 'staffId', 'content', 'evaluate']
        excelDownload(tHeader, filterVal, newArr, this.$i18n.t('lang.lab_elevatorManagement'))
      } else {
        this.$message.error(this.$i18n.t('lang.lab_Online'))
      }
    },
    // 所属小区下拉列表获取
    getGardenId() {
      let loading = this.$loading()
      this.$get(`/gardens`).then(res => {
        loading.close()
        if (res && res.errCode === 0) {
          this.types = res.list
        }
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
    // 获取电梯系统异常一级分类列表
    getSystemErroeLevel1() {
      this.type = 1
      let loading = this.$loading()
      this.$get(`/elevatorErrorSystems/?type=${this.type}&pageNo=1&pageSize=999`).then(res => {
        loading.close()
        if (res && res.errCode === 0) {
          this.elevatorErrorSystem1List = res.list
        }
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 获取电梯系统异常二级分类列表
    getSystemErroeLevel2() {
      this.type = 2
      this.elevatorErrorSystem2List = []
      this.elevatorErrorSystem2 = 0
      let loading = this.$loading()
      this.$get(`/elevatorErrorSystems/?type=${this.type}&Pid=${this.elevatorErrorSystem1}&pageNo=1&pageSize=999`).then(res => {
        loading.close()
        if (res && res.errCode === 0) {
          this.elevatorErrorSystem2List = res.list
          if (this.elevatorErrorSystem1 === 0) {
            this.elevatorErrorSystem2List = []
            this.elevatorErrorSystem2 = 0
          }
        }
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
    // 获取电梯部件异常一级分类列表
    getBodyErroeLevel1() {
      this.type = 1
      let loading = this.$loading()
      this.$get(`/elevatorErrorParts/?type=${this.type}&pageNo=1&pageSize=999`).then(res => {
        loading.close()
        if (res && res.errCode === 0) {
          this.elevatorErrorParts1List = res.list
        }
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
    // 获取电梯部件异常二级分类列表
    getBodyErroeLevel2() {
      this.elevatorErrorParts2List = []
      this.elevatorErrorParts3List = []
      this.elevatorErrorParts2 = 0
      this.elevatorErrorParts3 = 0
      this.type = 2
      let loading = this.$loading()
      this.$get(`/elevatorErrorParts/?type=${this.type}&Pid=${this.elevatorErrorParts1}&pageNo=1&pageSize=999`).then(res => {
        loading.close()
        if (res && res.errCode === 0) {
          this.elevatorErrorParts2List = res.list
          if (this.elevatorErrorParts1 === 0) {
            this.elevatorErrorParts2List = []
            this.elevatorErrorParts3List = []
            this.elevatorErrorParts2 = 0
            this.elevatorErrorParts3 = 0
          }
        }
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
    // 获取电梯部件异常三级分类列表
    getBodyErroeLevel3() {
      this.elevatorErrorParts3 = 0
      this.elevatorErrorParts3List = []
      this.type = 3
      let loading = this.$loading()
      this.$get(`/elevatorErrorParts/?type=${this.type}&Pid=${this.elevatorErrorParts2}&pageNo=1&pageSize=999`).then(res => {
        loading.close()
        if (res && res.errCode === 0) {
          this.elevatorErrorParts3List = res.list
          if (this.elevatorErrorParts2 === 0) {
            this.elevatorErrorParts3List = []
            this.elevatorErrorParts3 = 0
          }
        }
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 电梯管理列表
    getTablelist() {
      let loading = this.$loading()
      if (this.gardenId != 0) {
        this.GardenIdId = this.gardenId
      }
      this.$get(`/maintainElevatorError/?gardenId=${this.gardenId}&elevatorErrorSystem1=${this.elevatorErrorSystem1}&elevatorErrorSystem2=${this.elevatorErrorSystem2}&elevatorErrorParts1=${this.elevatorErrorParts1}&elevatorErrorParts2=${this.elevatorErrorParts2}&elevatorErrorParts3=${this.elevatorErrorParts3}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTablelist()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTablelist()
    },
    edit(id) {
      this.isPopupPage = true
      this.isAdd = false
      this.saveData = JSON.stringify(this.form)
      this.$router.push({ name: 'liftManagementInfo', query: { id: id } })
    },
    commit() {
      this.pageNo = 1
      this.getTablelist()
    }
  }
}
</script>

<style lang="scss">
  .liftManagementList {
    .filters {
      .el-select {
        width: 260px;
      }
    }
    .el-tooltip__popper.is-light {
      max-width: 300px;
    }
  }
  .el-tooltip__popper.is-light {
    max-width: 300px;
  }
</style>
